<template>
  <div class="date-editor center-ag-grid-editor">
    <RInput ref="input" v-model="date" :mask="mask" fill-mask="#" no-feedback-icon no-label no-hint on-clear="focus" />
  </div>
</template>

<script>
import { dateRenderer } from '@lib/generic.utils'
import { formatDateForPost } from '@lib/formatting.utils'
// Libraries
import moment from 'moment'

export default {
  name: 'DateEditor',

  data: () => ({
    date: null
  }),

  computed: {
    mask() {
      // convert date format to mask eg. DD/MM/YYYY to ##/##/####
      const dateFormat = this.settings.date_format.split('')
      return dateFormat.reduce((acc, curr) => {
        if (curr === '/') acc += curr
        else acc += '#'

        return acc
      }, '')
    }
  },

  created() {
    this.date = dateRenderer(this.params.value)
  },

  mounted() {
    this.$nextTick(() => this.$refs.input.focus())
  },

  methods: {
    getValue() {
      if (!this.date || this.date.includes('#') || !moment(this.date, this.settings.date_format).isValid()) return null

      return formatDateForPost(this.date, this.settings.date_format)
    }
  }
}
</script>
